module.exports = __webpack_public_path__ + "6c42ad3374db3e6db783753302783d37.pdf";